'use strict';

import _ from 'lodash';
import React from 'react';

class Custom extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    return <div className="sponsor clearfix">
        <div className="title">{this.props.custom.name}</div>
        <div dangerouslySetInnerHTML={{__html: this.props.custom.text}}></div>
      </div>
  }
}

export default Custom;
